/* tslint:disable */
/* eslint-disable */
/**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiCompetitorCompetitorIdGet200Response } from '../models';
/**
 * CompetitorApi - axios parameter creator
 * @export
 */
export const CompetitorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get competitor by id from Sportradar API
         * @param {string} competitorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompetitorCompetitorIdGet: async (competitorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitorId' is not null or undefined
            assertParamExists('apiCompetitorCompetitorIdGet', 'competitorId', competitorId)
            const localVarPath = `/api/competitor/{competitor_id}`
                .replace(`{${"competitor_id"}}`, encodeURIComponent(String(competitorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompetitorApi - functional programming interface
 * @export
 */
export const CompetitorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompetitorApiAxiosParamCreator(configuration)
    return {
        /**
         * Get competitor by id from Sportradar API
         * @param {string} competitorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompetitorCompetitorIdGet(competitorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiCompetitorCompetitorIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompetitorCompetitorIdGet(competitorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitorApi.apiCompetitorCompetitorIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompetitorApi - factory interface
 * @export
 */
export const CompetitorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompetitorApiFp(configuration)
    return {
        /**
         * Get competitor by id from Sportradar API
         * @param {CompetitorApiApiCompetitorCompetitorIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompetitorCompetitorIdGet(requestParameters: CompetitorApiApiCompetitorCompetitorIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiCompetitorCompetitorIdGet200Response> {
            return localVarFp.apiCompetitorCompetitorIdGet(requestParameters.competitorId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiCompetitorCompetitorIdGet operation in CompetitorApi.
 * @export
 * @interface CompetitorApiApiCompetitorCompetitorIdGetRequest
 */
export interface CompetitorApiApiCompetitorCompetitorIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CompetitorApiApiCompetitorCompetitorIdGet
     */
    readonly competitorId: string
}

/**
 * CompetitorApi - object-oriented interface
 * @export
 * @class CompetitorApi
 * @extends {BaseAPI}
 */
export class CompetitorApi extends BaseAPI {
    /**
     * Get competitor by id from Sportradar API
     * @param {CompetitorApiApiCompetitorCompetitorIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompetitorApi
     */
    public apiCompetitorCompetitorIdGet(requestParameters: CompetitorApiApiCompetitorCompetitorIdGetRequest, options?: RawAxiosRequestConfig) {
        return CompetitorApiFp(this.configuration).apiCompetitorCompetitorIdGet(requestParameters.competitorId, options).then((request) => request(this.axios, this.basePath));
    }
}

